import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppUtils } from '../../shared/helpers/app.utils';

@Injectable()
export class NetworkInterceptor implements HttpInterceptor {

    constructor(private readonly appUtils: AppUtils,
        private readonly snackBar: MatSnackBar
    ) {}

    intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 0) {
                    // Network error (e.g. ERR_INTERNET_DISCONNECTED)
                    console.error('No Internet Connection');
                }
                if (error.status === 429) {
                    this.appUtils.showError(this.snackBar, "Too many requests. Please wait a moment and try again.");
                }
                return throwError(() => error);
            })
        );
    }
}
